import React from 'react';
import { cn } from '../index';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  containerClassName?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, containerClassName, error, ...props }, ref) => (
    <div className={cn('w-full', containerClassName)}>
      <input
        ref={ref}
        className={cn(
          'flex h-9 w-full rounded-lg border px-3 py-2 text-sm transition-colors',
          'bg-[var(--input)] border-[var(--input-border)] text-[var(--fg)]',
          'placeholder:text-[var(--input-placeholder)]',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:border-transparent',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          error && 'border-[var(--destructive)] focus-visible:ring-[var(--destructive)]',
          className,
        )}
        {...props}
      />
      {error && <p className="mt-1 text-xs text-[var(--destructive)]">{error}</p>}
    </div>
  ),
);
Input.displayName = 'Input';
